import Vue from 'vue'
import Vuex from 'vuex'

import { basketState, basketGetters, basketMutations, basketPlugins } from './basket'

Vue.use(Vuex)

export default new Vuex.Store({
    state: basketState,
    getters: basketGetters,
    mutations: basketMutations,
    plugins: [ basketPlugins ],
})


// WEBPACK FOOTER //
// ./src/store/index.js